import React from "react";
import { MenuProps } from "react-select";

const HeaderSearchMenu: React.FC<MenuProps<any>> = ({ children }) => {
  return <div className="search-menu">{children}</div>;
};

export default HeaderSearchMenu;
